<template>
  <v-app id="inspire">
    <v-content >
      <v-container fluid fill-height >

                <v-layout align-center column fill-heigh justify-center  >
                  <div class="action">
                    <semipolar-spinner
                      :animation-duration="2000"
                      :size="115"
                      color="#1935ff"
                    />
                  </div>

                </v-layout>

      </v-container>
    </v-content>

  </v-app>

</template>

<script>
  import {SemipolarSpinner} from 'epic-spinners'

  export default {
    name: 'LoadSys',
    components: {
      SemipolarSpinner,
    },
    created() {

        setTimeout(() => {
          if (window.$cookies.isKey('userMuctr')) {
            this.$router.push({ name: 'OpenDiss' });
          }else{
             this.$router.push({ name: 'OpenDiss' });
          }
        }, 500);

      }

  }
</script>

<style scoped>

</style>
